var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87451 0.875C7.87451 0.391751 7.48276 0 6.99951 0C6.51626 0 6.12451 0.391751 6.12451 0.875V6.125H0.874512C0.391263 6.125 -0.000488281 6.51675 -0.000488281 7C-0.000488281 7.48325 0.391263 7.875 0.874512 7.875H6.12451V13.125C6.12451 13.6082 6.51626 14 6.99951 14C7.48276 14 7.87451 13.6082 7.87451 13.125V7.875H13.1245C13.6078 7.875 13.9995 7.48325 13.9995 7C13.9995 6.51675 13.6078 6.125 13.1245 6.125H7.87451V0.875Z",
    fill: "#121622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.65b2b36b56c9fbf23318c9a20a579fbc.svg";
export { ForwardRef as ReactComponent };